<template>
  <div v-if="stats" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <!-- Card 1: Total Productos -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Total Productos</span>
        <div class="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center text-lg">
          <i class="fa fa-boxes-stacked" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-gray-900">{{ stats.total ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">Artículos registrados en catálogo</p>
      </div>
    </div>

    <!-- Card 2: Valor del Inventario -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Valor Inventario</span>
        <div class="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center text-lg">
          <i class="fa fa-money-bill-trend-up" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-emerald-600">{{ formatCurrency(stats.inventory_value ?? 0) }}</p>
        <p class="text-xs text-gray-400 mt-1">Capital estimado en stock</p>
      </div>
    </div>

    <!-- Card 3: Stock Bajo / Agotados -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Stock Bajo / Agotado</span>
        <div class="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center text-lg">
          <i class="fa fa-triangle-exclamation" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-amber-600">{{ stats.low_stock ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">Artículos con 5 o menos unidades</p>
      </div>
    </div>

    <!-- Card 4: Nuevos este Mes -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Nuevos este Mes</span>
        <div class="w-10 h-10 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center text-lg">
          <i class="fa fa-plus-circle" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-purple-600">{{ stats.new_this_month ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">Artículos agregados este mes</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductStats',

  props: {
    stats: {
      type: Object,
      default: () => ({
        total: 0,
        inventory_value: 0,
        low_stock: 0,
        new_this_month: 0,
      }),
    },
  },

  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(value || 0)
    },
  },
}
</script>
